import t from 'tcomb';

export default t.interface({
  badge_earned_id: t.String
}, { strict: true, name: 'BadgesEarned' });

